// src/data/titleContent.js

export const titleContent = {
  mobile: {
    header: "Merchandise Planning Analyst",
    subheader: "Demand Forecasting · Retail Math · Pricing · Power BI",
    paragraph: "I own the full loop — from the data to the forecast to the decision."
  },
  desktop: {
    header: "Merchandise Planning Analyst",
    subheader: "Demand Forecasting & Retail Math · Pricing & Revenue · Retail & E-Commerce · Open to Relocation",
    paragraph:
      "I turn retail data into decisions — building forecasting models, dashboards, and reporting frameworks that drive inventory, pricing, and revenue strategy. Open to Merchandise Planner, Demand Planner, Pricing Analyst, and BI Analyst roles."
  }
};